/** Iter 50 — pure helpers for the disposition stale auto-check result an import returns. */

/** True when the check ran and changed or still shows something worth a look. */
export function staleCheckNeedsAttention(check) {
  if (!check?.stale_checked) return false;
  return (check.stale_flagged || 0) > 0 || (check.stale_cleared || 0) > 0 || (check.stale_total || 0) > 0;
}

/** One-line summary used by the toast and the inline notice. */
export function staleCheckMessage(check) {
  if (!check) return null;
  if (!check.stale_checked) {
    return check.skipped_reason ? `Disposition stale check skipped — ${check.skipped_reason}.` : null;
  }
  const flagged = check.stale_flagged || 0;
  const cleared = check.stale_cleared || 0;
  const total = check.stale_total || 0;
  const n = check.checked_dispositions || 0;
  let msg = `Disposition stale check complete — ${n} row${n === 1 ? "" : "s"} checked, ${flagged} flagged stale, ${cleared} cleared`;
  if (total > 0) msg += `, ${total} stale in total`;
  return `${msg}.`;
}

/** Route to the matrix filtered to stale rows — only when there is something to see. */
export function staleCheckLink(workspaceId, check) {
  if (!check?.stale_checked || !(check.stale_total > 0)) return null;
  return `/workspaces/${workspaceId}/dispositions?stale=true`;
}
